import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng/ui_base';
import { handleAd } from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import ListTitle from './listTitle';
import TitleImg from './titleImg';
import { isIE78 } from '../../../utils/utils';
import { rel } from '../../../utils/rel';

const formatList = (list, ads) => {
    for (const ad of ads) {
        if (ad.type === 'replaceArr') {
            list.splice(ad.index, 1, { type: 'ad', ref: ad.ref });
        } else if (ad.type === 'insertArr') {
            list.splice(ad.index, 0, { type: 'ad', ref: ad.ref });
        }
    }

    return list;
};

class NewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        hasTitle: PropTypes.bool,
        hasTitleImg: PropTypes.bool,
        isVideoList: PropTypes.bool,
        isBig: PropTypes.bool,
        isFirstBold: PropTypes.bool,
        size: PropTypes.string,
        ad: PropTypes.object,
    };

    state = {
        ads: [],
    };

    event = new Event();

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const refs = [];

            replaceArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'replaceArr' });
            });

            insertArr.forEach(index => {
                const ref = React.createRef();

                refs.push({ index, ref, type: 'insertArr' });
            });

            this.setState(
                {
                    ads: [...this.state.ads, ...refs],
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        const { ad } = this.props;

        if (ad) {
            try {
                const callback = await handleAd(ad);

                callback(ad.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    }

    handleListStyle = pcNewsMark => {
        const { isVideoList } = this.props;

        const maskStyle = [];
        let isVideo = false;
        let hasZoujc = false;

        if (pcNewsMark && pcNewsMark.length > 0) {
            if (pcNewsMark.indexOf(1) > -1) {
                maskStyle.push(styles.bold);
            }

            if (pcNewsMark.indexOf(2) > -1) {
                isVideo = true;
            }

            if (pcNewsMark.indexOf(3) > -1) {
                hasZoujc = true;
            }

            if (pcNewsMark.indexOf(4) > -1) {
                maskStyle.push(styles.cnRed);
            }
        }

        isVideo = isVideo || isVideoList;

        return {
            isVideo,
            hasZoujc,
            maskStyleName: maskStyle.join(' '),
        };
    };

    render() {
        const { ads } = this.state;
        const { content, hasTitle, hasTitleImg, isBig, size, isFirstBold } = this.props;
        let titleData = [];
        let data = [...content];

        data = formatList(data, ads);

        if (hasTitle || hasTitleImg) {
            titleData = data.slice(0, 1);
            data = data.slice(1);
        }

        /* eslint-disable no-confusing-arrow */
        return (
            <div className={styles.news_list}>
                {hasTitleImg ? <TitleImg size={size} content={titleData[0]} /> : ''}
                {hasTitle ? <ListTitle isBig={isBig} content={titleData} /> : ''}
                {data.map((item, index) => {
                    if (item.type === 'ad') {
                        return <li key={index} ref={item.ref} />;
                    }

                    const { isVideo, hasZoujc, maskStyleName } = this.handleListStyle(item.pcNewsMark);

                    return (
                        <p key={index}>
                            {hasZoujc ? <span className={styles.zoujc} /> : ''}
                            {isVideo ? <span className={isIE78() ? styles.video : styles.video_2x} /> : ''}
                            {item.children && item.children.length > 0 ? (
                                <React.Fragment>
                                    <a
                                        className={`${maskStyleName} ${styles.space} ${
                                            isFirstBold && index === 0 ? styles.bold : ''
                                        }`}
                                        title={item.title}
                                        href={item.url}
                                        target="_blank"
                                        rel={rel}>
                                        {item.title}
                                    </a>
                                    {item.children.map((child, ind) => {
                                        const { maskStyleName } = this.handleListStyle(child.pcNewsMark);

                                        return (
                                            <a
                                                key={ind}
                                                className={`${maskStyleName} ${styles.space} ${
                                                    isFirstBold && index === 0 ? styles.bold : ''
                                                }`}
                                                title={item.title}
                                                href={child.url}
                                                target="_blank"
                                                rel={rel}>
                                                {child.title}
                                            </a>
                                        );
                                    })}
                                </React.Fragment>
                            ) : (
                                <a
                                    className={`${maskStyleName} ${isFirstBold && index === 0 ? styles.bold : ''}`}
                                    title={item.title}
                                    href={item.url}
                                    target="_blank"
                                    rel={rel}>
                                    {item.title}
                                </a>
                            )}
                        </p>
                    );
                })}
            </div>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(NewsList);
